/* eslint-disable global-require */
/* eslint-disable max-len */
/**
 * home页配置
 */
export default {
  // 数据比例
  dataProportion: {
    title: 'Provides top quality teaching to millions of students worldwide',
  },

  // 服务
  service: {
    title: 'What we provide',
    serviceList: [{
      title: 'Parent Sit-in Welcomed',
      description: '',
    }, {
      title: 'Interactive Platform',
      description: '',
    }, {
      title: 'Unlimited Lesson Playback',
      description: '',
    }, {
      title: 'Progress and Achievement Tracking Report',
      description: '',
    }, {
      title: 'Flexible Session Transfer',
      description: '',
    }, {
      title: 'One-Click Refund Policy',
      description: '',
    }],
  },

  // 教学效果
  teachingEffect: {
    title: 'What makes Think Academy so Effective?',
    description: 'Our lessons and teaching methods are unique, effective and engaging. With over <span>17</span> years’ experience and over <span>900,000+</span> questions under our belt, we know exactly what is required to deliver online teaching to the highest standard.',
  },

  // 品牌介绍
  brandEndorsement: {
    title: 'Think Academy, first oversea branch of TAL Education Group',
    description: `
      <p>TAL is dedicated to education, with over 17 years of experience. TAL Founded in 2003, Tomorrow Advancing Life was listed on the New York Stock Exchange (NYSE:TAL) in October 2010, becoming the first Chinese education institution for primary and middle school students to be listed in the United States.</p>
      <p>TAL is a leading education and technology enterprise in China, whose core goals are being technology-driven, talent-centred, and quality-focused. Since its establishment, TAL has been committed to integrating technologies and the Internet into education, to deliver a better learning experience for students.</p>
    `,
  },

  // 首页跳转免费课
  selectGrade: {
    title: 'Choose a Maths Course for Your Child',
    placeholder: 'Choose School Year',
    // btnText: 'View available courses',
    btnText: 'View courses',
  },
  // 核心优势
  coreAdvantages: {
    title: 'Why choose Think Academy?',
    advantages: [
      {
        name: 'Learn from the Best Math Experts',
        description: 'Our teachers are graduates of the top 50 universities in China and the top 100 in the world.',
        picture: require('assets/images/home/my/1-study-plan.jpg'),
      },
      {
        name: 'Small Class Size x EdTech-Powered Learning',
        description: 'Before, during and after lessons, our teacher partners you and your child - ensuring attentiveness and engagement during live classes, marking homework, providing timely feedback for improvement.',
        picture: require('assets/images/home/my/2-discussion.jpg'),
      },
      {
        name: 'Excellent Achievements in CMO & IMO Think Academy\'s students have won:',
        description: `
        - SMOPS, NMOS and Mathlympics Awards
        - 17 Gold Awards at the International Math Olympiad (IMO)
        - Top 10 positions in Harvard-MIT Mathematics Tournament (HMMT) Guts Round and top 5 for Team Rounds
        - Over 100 Gold Awards at the Chinese Mathematical Olympiad (CMO)... and more.
        `,
        picture: require('assets/images/home/my/3-math-olympians.jpg'),
      },
      {
        name: 'Top Global Education Resources',
        description: 'With 18 years of teaching experience in mainland China, where we have trained numerous students to enter world-class universities, and a branch in Silicon Valley, London and Singapore, we will provide Malaysian students with world-class teaching resources.',
        picture: require('assets/images/home/my/4-online-teaching.jpg'),
      },
    ],
  },

  // our programmes
  ourProgrammes: {
    title: 'Our Programmes',
    listData: [{
      title: 'Mathematics Olympiad, Competition',
      description: 'Mathematics and various local competitions and examinations in Malaysia Learn advanced higher order thinking skills, mathematical heuristics and topics to excel in the Mathematics Olympiad as well as various Malaysian examinations such as Math Kangaroo, SASMO, AMC, IMO.',
      picture: require('assets/images/home/my/programmes-1.jpg'),
    }, {
      title: 'Improving mathematical thinking skills',
      description: 'Improve logical reasoning, abstract thinking and creative problem solving skills. Focus on improving mathematical thinking skills in primary schools to help children achieve good results in future SPM, UEC, IGCSE and other examinations.',
      picture: require('assets/images/home/my/programmes-2.jpg'),
    }, {
      title: 'Advanced Primary School Syllabus Math',
      description: 'Increased pace, depth and breadth of Math knowledge and skills beyond the school syllabus, including introductory Math Olympiad thinking abilities for strengthened logical reasoning.',
      picture: require('assets/images/home/my/programmes-3.jpg'),
    }, {
      title: 'PSLE Math',
      description: 'PSLE Math intensive programmes to master high-frequency topical knowledge and skills, effective problem solving techniques and exam preparation habits and skills to score well in school examinations, prelims and the PSLE.',
      picture: require('assets/images/home/my/programmes-4.jpg'),
    }],
  },

  // 课堂介绍配置
  platformIntro: {
    title: `Think Academy’s live-streamed classes are enriched by a 
    series of innovative & interactive features`,
    picIntroList: [
      {
        pictureClass: 'uk-platform-intro-1',
        picture: require('assets/images/free-trial-class/my/intro1.png'),
        title: 'Interactive features keep young learners focused and engaged',
        description: 'Discover quizzes, games, animations, 1-to-1 video links directly with the tutor, virtual rewards, and more!',
      },
      {
        pictureClass: 'uk-platform-intro-2',
        picture: require('assets/images/free-trial-class/my/intro2.png'),
        title: 'Fun and engaging online classes',
        description: 'Experience guided teaching, fun quizzes, and maths games to encourage students to learn and participate. Students can also earn virtual rewards and exchange them for virtual gifts.',
      },
      {
        pictureClass: 'uk-platform-intro-3',
        picture: require('assets/images/free-trial-class/my/intro3.png'),
        title: 'Personalised reports and guided learning service',
        description: 'We regularly review students’ homework and provide feedback on their performance, tracking progress and regularly reporting to parents so that no child will fall behind.',
      },
    ],
  },

  // 教师介绍模块
  teacherIntro: {
    title: 'Our Expert Maths Teachers',
    description: 'We\'ve drawn on our entrance exam expertise to design all our maths courses. That\'s why we\'re able to offer a unique learning pathway to each student based on the level of support they require.',
    btnText: 'Learn more',
  },

  // 用户评论
  parentsSay: {
    title: 'Think Academy Testimonials',
    content: [
      {
        name: 'Rachel Gilling',
        status: 'Parent of a Year 3 pupil',
        comment: '"Hi Gina, thanks so much. Overall we\'re very pleased with the lesson content and the length of each lesson. Henry seems to have a newfound interest in maths. We\'re looking forward to the Year 4 autumn course. We\'d also like to thank you for support and continued updates on his progress."',
      },
      {
        name: ' Hannah Low',
        status: ' Parent of a Year 5 student',
        comment: '"Thanks Think Academy!! Tim\'s teacher said he\'s made a complete turnaround in maths and it\'s no doubt thanks to your help. Please thank Oli too. We really appreciate this!"',
      },
      {
        name: ' Chris Yu',
        status: 'Parent of a Year 6 student',
        comment: '"Thank you Evelyn, it\'s fabulous! The final test is just what we need now! Thanks for all the hard work! Think Academy becomes better and better; its super at the moment!"',
      },
      {
        name: 'Jennifer',
        status: 'Parent of a Year 5 student',
        comment: '"Thank you very much for the learning report and your effort in assisting William to learn is greatly appreciated! We will enroll in the autumn term for sure and hope to see you then. Have a great summer holiday and enjoy the well deserved break."',
      },
      {
        name: 'Catherine Turner',
        status: 'Parent of a Year 3 student',
        comment: '"I feel as though the Think Academy course goes beyond what kids are being taught in school. My child\'s arithmetic improved leaps and bounds in such a short time."',
      },
      {
        name: 'Alsion Abu',
        status: 'Parent of a Year 4 student',
        comment: "My son found the classes very useful and learnt a lot of new topics. Recaps at the start of class were really effective for him, building up his confidence. We're happy with the progress he's made so far.",
      },
      {
        name: 'Nick Chen',
        status: 'Parent of a Year 2 student',
        comment: "The couse went well, my daughter is in Year 2 and so I was concerned she might lose focus in class. The lessons are interactive and the tutor is great at helping her to refocus with fun games and other enjoyable activities. We're confident she'll perform well in the 7+.",
      },
    ],
  },

  getNotifiedConfig: {
    title: 'Can\'t find the right course for your child?',
    // eslint-disable-next-line max-len
    description: 'No problem! While you\'re taking a moment to think, leave us your email for more free materials and videos on mathematical thinking exercises',
    form: {
      grade: 'Child\'s Year group',
      firstName: 'Child\'s first name',
      lastName: 'Last name',
      email: 'Your email',
      platform: 'How did you find out about us?',
    },
    notice: 'Sign up for our mailing list to receive the latest news, promotions and updates! ',
    submit: 'Submit',
    success: 'Thank you for your interest in Think Academy!',

  },

}
